
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsb1815d7fa5160a8956e5771e2d4388ceen from './en.yaml'
            i18n.addResourceBundle('en', 'b1815d7fa5160a8956e5771e2d4388ce', flattenObject(nsb1815d7fa5160a8956e5771e2d4388ceen), true, true);
        
        export default 'b1815d7fa5160a8956e5771e2d4388ce';
    